import React, { useContext, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../assets/AdminCss/cricket.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { AuthContext, base_url } from "../../../context/Authcontext";

import TennisScoreboard from "../../TennisScoreboard";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import BetModal from "./BetModal";

const SECRET_KEY = "yourSuperSecret123";

const HomeTennis = () => {
  // const { marketId2 } = useParams();
  //   console.log("marketnmndm", marketId2);
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );
  //   console.log( "trgyjbrh3kgk" ,marketId2); // e.g., "34359959"
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const location = useLocation();
  const [back1, setBack1] = useState([]);
  const [lay1, setLay1] = useState([]);
  const [back2, setBack2] = useState([]);
  const [fancyBetData, setFancyBetData] = useState([]);
  const [lay2, setLay2] = useState([]);

  const [profit, setProfit] = useState(0);
  const [pr, setPr] = useState(0);

  const [side, setSide] = useState("");
  const [oddsDelay, setOddsDelay] = useState();

  const [selectedPrice, setSelectedPrice] = useState();
  const [money, setMoney] = useState(0);
  const { isAuthenticated } = useContext(AuthContext);

  const [marketId, setMarketId] = useState(() => {
    return location.state?.marketId || sessionStorage.getItem("marketId") || "";
  });

  const [marketId2, setMarketId2] = useState(() => {
    return location.state?.marketId || sessionStorage.getItem("marketId") || "";
  });

  const [runner1, setRunner1] = useState(() => {
    return location.state?.runner1 || sessionStorage.getItem("runner1") || "";
  });

  const [runner2, setRunner2] = useState(() => {
    return location.state?.runner2 || sessionStorage.getItem("runner2") || "";
  });
  const [runner3, setRunner3] = useState(() => {
    return location.state?.runner3 || sessionStorage.getItem("runner3") || "";
  });

  const [selectedId, setSelectedId] = useState(0);
  const [runner, setRunner] = useState("");

  const competiton = sessionStorage.getItem("competitionname");
  const event = sessionStorage.getItem("eventname");
  const selectionid1 = sessionStorage.getItem("selectionid1");
  const selectionid2 = sessionStorage.getItem("selectionid2");
  const selectionid3 = sessionStorage.getItem("selectionid3");

  const eventId = sessionStorage.getItem("eventid");
  const [startTime, setStartTime] = useState();

  const [channel, setChannel] = useState();
  const [betData, setBetData] = useState([]);
  const [play, setPlay] = useState(false);
  const [minOdds, setMinOdds] = useState(0);
  const [maxOdds, setMaxOdds] = useState(0);
  const [unmatch, setUnmatch] = useState([]);
  const [matchLiabilities, setMatchLiabilities] = useState({
    odds: {},
    bookmaker: {},
    mini_bookmaker: {},
    oddsDiff: {},
    bookmakerDiff: {},
    miniBookmakerDiff: {},
  });

  // bet form data
  const [formData, setFormData] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "odds",
    betAmount: 0,
    profit: 0,
    side: "",
    sportName: "tennis",
  });

  // console.log('selec',selectedMarket);

  // console.log('iidd',marketId);

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  useEffect(() => {
    const getTimeDelay = async () => {
      try {
        const response = await axios.get(
          base_url + "/api/get/webapi/sportsData/timeDelay",
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );
        if (response?.data.success) {
          if (response?.data?.betDelay?.length > 0) {
            let timeDelayData = response?.data.betDelay;
            const delays = timeDelayData[0] || "";

            const oddss = JSON.parse(delays?.match_odds_tennis);
            const oddsDelay = oddss?.bet_delay || 0;
            const minBet = oddss?.min_bet || 0;
            const maxBet = oddss?.max_bet || 0;
            // console.log(minBet);
            setMinOdds(minBet);
            setMaxOdds(maxBet);
            setOddsDelay(oddsDelay * 1000);
          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    getTimeDelay();
  }, []);

  // console.log("market id 2" , marketId2);
  const betDataa = async () => {
      const marketId = sessionStorage.getItem("marketId");
      // console.log("marketid ", marketId)
      try {
          const response = await axios.post(
              base_url + "/admin/webapi/betData",
              { marketId },
              {
                  withCredentials: true,
                  headers: {
                      "content-type": "application/json",
                  },
              }
          );

          // console.log("databet", response);

          if (response?.data.success) {
              const sportsBets = response?.data.sportsBets;
              const fancyBets = response?.data.fancyBets;
              const unmach = response?.data.unmatch;
              // console.log('ddd',data);
              setBetData(sportsBets);
              setFancyBetData(fancyBets);
              setUnmatch(unmach);
          }
      } catch (err) {
          console.log(err);
      }
  };
  betDataa();

  // formdata odds

  useEffect(() => {
    if (location.state?.marketId) {
      sessionStorage.setItem("marketId", location.state.marketId);
      setMarketId(location.state.marketId);
    }

    if (location.state?.marketId) {
      sessionStorage.setItem("marketId", location.state.marketId);
      setMarketId2(location.state.marketId);
    }

    if (location.state?.runner1) {
      sessionStorage.setItem("runner1", location.state.runner1);
      setRunner1(location.state.runner1);
    }

    if (location.state?.runner2) {
      sessionStorage.setItem("runner2", location.state.runner2);
      setRunner2(location.state.runner2);
    }

    if (location.state?.runner3) {
      sessionStorage.setItem("runner3", location.state.runner3);
      setRunner3(location.state.runner3);
    }

    const liveTv = async () => {
      try {
        const response = await axios.get(base_url + "/api/webapi/liveTv");
        const live = response?.data.result;
        const matchedData = live.filter(
          (item) => item.MatchID === parseFloat(eventId)
        );
        const channel = matchedData[0].Channel;

        // Get the TV URL from your API
        const respone = await axios.post(base_url + "/api/webapi/tv/channel", {
          channel,
        });
        const tvLink = respone?.data.message;

        // Set the full URL with proper encoding
        setChannel(encodeURI(tvLink));
      } catch (err) {
        console.log(err);
      }
    };

    const proft =
      parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
    setProfit(proft.toFixed(1));

    // console.log('prff',proft);
    // Add event listener for resize

    liveTv();

    // Cleanup the event listener on component unmount
    return () => {
      //   window.removeEventListener("resize", handleResize);
      // sessionStorage.clear();
    };
  }, [location.state, money, selectedPrice]);

  useEffect(() => {
    window.scrollTo(0, 0);

    const backLay = async () => {
      try {
        const marketId = sessionStorage.getItem("marketId");
        const response = await axios.get(
          base_url + `/api/webapi/market/${marketId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log('reees', response.data.result);
        const status1 = response?.data.result[0]?.status;
        const status2 = response?.data.result[1]?.status;
        const status3 = response?.data.result[2]?.status;
        // console.log(status1);
        // console.log(status2);

        if (status1 === "ACTIVE") {
          const backk1 = response?.data.result[0]?.ex?.availableToBack;
          const layy1 = response?.data.result[0]?.ex?.availableToLay;

          setBack1(backk1);
          setLay1(layy1);
        }

        if (status2 === "ACTIVE") {
          const backk2 = response?.data.result[1]?.ex?.availableToBack;
          const layy2 = response?.data.result[1]?.ex?.availableToLay;

          setBack2(backk2);
          setLay2(layy2);
        }
      } catch (err) {
        console.log("Error fetching in odds data", err);
      }
    };

    const calculateAdminPnLByMarket = (userBets, team1, team2) => {
      const marketTypes = ["odds", "bookmaker", "mini_bookmaker"];
      const result = {};

      marketTypes.forEach((market) => {
        const marketBets = userBets.filter(
          (b) => b.type.toLowerCase() === market
        );

        const runnerPnl = {};
        const runners = new Set(marketBets.map((b) => b.runnerName));
        runners.add(team1);
        runners.add(team2);
        const runner3 = sessionStorage.getItem("runner3");
        if (runner3 && runner3.toLowerCase() === "the draw") {
          runners.add("The Draw");
        }

        for (const runner of runners) {
          runnerPnl[runner] = 0;
        }

        // Reverse user's PnL to get admin's profit/loss
        marketBets.forEach(({ runnerName, side, betprice, betAmount }) => {
          const odds = parseFloat(betprice);
          const stake = parseFloat(betAmount);

          for (const currentRunner of runners) {
            if (currentRunner === runnerName) {
              if (side === "Back") {
                runnerPnl[currentRunner] -= (odds - 1) * stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] += (odds - 1) * stake;
              }
            } else {
              if (side === "Back") {
                runnerPnl[currentRunner] += stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] -= stake;
              }
            }
          }
        });

        // Round to 2 decimal places
        Object.keys(runnerPnl).forEach((runner) => {
          runnerPnl[runner] = parseFloat(runnerPnl[runner].toFixed(2));
        });

        const liability = Object.values(runnerPnl).length
          ? Math.min(...Object.values(runnerPnl))
          : '';

        result[market] = {
          pnl: runnerPnl,
          liability: parseFloat(liability.toFixed(2)),
        };
      });

      return result;
    };

    const getMatchLiablities = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/webapi/getAdminMatchLiablity/${eventId}`,
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );

        const bets = response.data;
        const { team1, team2 } = bets[0] || {};

        const adminResult = calculateAdminPnLByMarket(bets, team1, team2);

        setMatchLiabilities(adminResult); // or return this if using backend
      } catch (err) {
        console.error("Error fetching admin P/L:", err);
      }
    };

    const sessiontime = sessionStorage.getItem("time");
    const time = formatDate(sessiontime);
    // console.log('time',time);
    setStartTime(time);

    const updateData = () => {
      backLay();
      getMatchLiablities();
    };

    const intervalId = setInterval(updateData, 1000);

    // Cleanup function to clear interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // console.log('matchess',wpMarket);

  // betformdata
  formData.selectionId = selectedId;
  formData.runnername = runner;
  formData.betAmount = money;
  formData.profit = profit;
  formData.eventid = eventId;
  formData.betPrice = selectedPrice;
  formData.side = side;

  return (
    <>
      <div className="wrapper">
        {/* Main Sidebar */}
        {/* <AdminSidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />

        <AdminHeader
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}

        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"
            }`}
          style={{
            marginLeft: !isMobile && isSidebarOpen ? "" : "0",
            transition: "margin-left 0.3s ease",
          }}
        >
          <div _ngcontent-jrx-c95="" className="head-containerr p-2">
            <div _ngcontent-jrx-c95="" className="body-container">
              <div className="mt-3 d-flex flex-column flex-lg-row justify-content-between mainn w-100 p-2">
                <div className="match-content">
                  <div className="d-flex gap-5 align-items-center">
                    <span className="text-info fs-5 inline">
                      Start Time: &nbsp;{startTime}
                    </span>
                    {/* <span>Time Remaining: </span> */}
                  </div>

                  <TennisScoreboard></TennisScoreboard>

                  <div className="d-flex justify-content-between">
                    <div>
                      <span className="text-dark fw-bold fs-5">{runner1}</span>{" "}
                      :{" "}
                      <span
                        className={`${parseFloat(
                          matchLiabilities?.odds?.pnl?.[runner1]
                        ) +
                          parseFloat(
                            matchLiabilities?.bookmaker?.pnl?.[runner1]
                          ) <
                          0
                          ? "text-red"
                          : "text-green"
                          }`}
                      >
                        {parseFloat(
                          matchLiabilities?.odds?.pnl?.[runner1]
                        ) +
                          parseFloat(
                            matchLiabilities?.bookmaker?.pnl?.[runner1]
                          )}
                      </span>
                    </div>

                    <div>
                      <span className="text-dark fw-bold fs-5">{runner2}</span>{" "}
                      :{" "}
                      <span
                        className={`${parseFloat(
                          matchLiabilities?.odds?.pnl?.[runner2]
                        ) +
                          parseFloat(
                            matchLiabilities?.bookmaker?.pnl?.[runner2]
                          ) <
                          0
                          ? "text-red"
                          : "text-green"
                          }`}
                      >
                        {parseFloat(
                          matchLiabilities?.odds?.pnl?.[runner2]
                        ) +
                          parseFloat(
                            matchLiabilities?.bookmaker?.pnl?.[runner2]
                          )}
                      </span>
                    </div>
                  </div>

                  <div className="match-section">
                    <div className="match-header d-flex align-items-end gap-2 ">
                      <div className="d-flex flex-lg-row flex-column  flex-md-row align-items-baseline">
                        <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                          Match Odds
                        </p>
                        {/* <p className="d-flex gap-1 fszz">
                            <span>
                              Min:{minOdds} <span>|</span>{" "}
                            </span>{" "}
                            Max:{maxOdds}
                          </p> */}
                      </div>
                      <BetModal betData={betData} />
                      {/* <p className="btn btn-success rounded-pill text-black" style={{ marginBottom: "14px" }}>
  <i className="bi bi-book"></i>
</p> */}

                      <div
                        className="d-flex align-items-end gap-4 ms-0 ms-md-auto me-4 mt-2 mt-md-0"
                        style={{ height: "5rem" }}
                      >
                        <p className="text-info fs-5">Back</p>
                        <p className="text-pink fs-5">Lay</p>
                      </div>
                    </div>

                    <div
                      className="betting-options d-flex flex-column p-2 gap-2"
                      style={{ marginLeft: "-10px" }}
                    >
                      <div className="betting-row d-flex flex-md-row justify-content-between align-items-center border-2 bg-dark p-2">
                        <h5
                          className="fs-4 text-wrap run d-flex flex-column gap-1"
                          id={selectionid1}
                        >
                          {runner1}
                          <span
                            className={`${matchLiabilities?.odds?.pnl?.[runner1] < 0
                              ? "text-red"
                              : "text-green"
                              }`}
                          >
                            {matchLiabilities?.odds?.pnl?.[runner1]}
                          </span>
                        </h5>

                        <div className="d-flex gap-2">
                          {back1
                            .slice()
                            .reverse()
                            .map((bc, index) => (
                              <div
                                className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${index < back1?.length - 1
                                  ? "bg-secondary dnone"
                                  : "bg-info"
                                  }`}
                                style={{ width: "4rem" }}
                              >
                                {bc.price}
                              </div>
                            ))}

                          {lay1.map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                              style={{
                                width: "4rem",
                                backgroundColor: "#E83E8C",
                              }}
                            >
                              {bc.price}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-2 bg-dark p-2">
                        <h5
                          className="fs-4 text-wrap run d-flex flex-column gap-1"
                          id={selectionid2}
                        >
                          {runner2}
                          <span
                            className={`${matchLiabilities?.odds?.pnl?.[runner2] < 0
                              ? "text-red"
                              : "text-green"
                              }`}
                          >
                            {matchLiabilities?.odds?.pnl?.[runner2]}
                          </span>
                        </h5>

                        <div className="d-flex  gap-2">
                          {back2
                            .slice()
                            .reverse()
                            .map((bc, index) => (
                              <div
                                className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index < back2?.length - 1
                                  ? "bg-secondary dnone"
                                  : "bg-info"
                                  }`}
                                style={{ width: "4rem" }}
                              >
                                {bc.price}
                              </div>
                            ))}

                          {lay2.map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                              style={{
                                width: "4rem",
                                backgroundColor: "#E83E8C",
                              }}
                            >
                              {bc.price}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="match-section">
                    <div className="match-header d-flex align-items-end gap-2 ">
                      <div className="d-flex flex-lg-row flex-column  flex-md-row align-items-baseline">
                        <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                          BOOKEMAKER
                        </p>
                        <p className="d-flex gap-1 fszz">
                          <span>
                            Min:100 <span>|</span>{" "}
                          </span>{" "}
                          Max:50k
                        </p>
                      </div>

                      <BetModal betData={betData} type="odds" />

                      <p className="btn btn-success rounded-pill text-black" style={{ marginBottom: "14px" }}>
                        <i className="bi bi-book"></i>
                      </p>

                      <div
                        className="d-flex align-items-end gap-4 ms-0 ms-md-auto me-4 mt-2 mt-md-0"
                        style={{ height: "5rem" }}
                      >
                        <p className="text-info fs-5">Back</p>
                        <p className="text-pink fs-5">Lay</p>
                      </div>
                    </div>

                    <div
                      className="betting-options d-flex flex-column p-2 gap-2"
                      style={{ marginLeft: "-10px" }}
                    >
                      <div className="betting-row d-flex flex-md-row justify-content-between align-items-center border-2 bg-dark p-2">
                        <h5 className="fs-4 text-wrap run" id={selectionid1}>
                          {runner1}
                        </h5>

                        <div className="d-flex gap-2">
                          SUSPENDED

                          {back1.slice().reverse().map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${index < back1.length - 1
                                  ? "bg-secondary dnone"
                                  : "bg-info"
                                }`}
                              onClick={() => {
                                setbackActive(1);
                                setlayActive(3);
                                setSelectedPrice(bc.price);
                                setPr(1);
                                setSelectedId(selectionid1);
                                setRunner(runner1);
                                setSide('Back');
                                setSelectedBet(0)
                              }}
                              style={{ width: '4rem' }}
                            >
                              {bc.price}
                            </div>
                          ))}



                          {lay1.map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                              onClick={() => {
                                setlayActive(4);
                                setbackActive(0);
                                setSelectedPrice(bc.price);
                                setPr(2);
                                setSelectedId(selectionid1);
                                setRunner(runner1);
                                setSide('Lay');
                                setSelectedBet(0);
                              }}
                              style={{ width: '4rem' }}
                            >
                              {bc.price}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-2 bg-dark p-2">
                        <h5 className="fs-4 text-wrap run" id={selectionid2}>
                          {runner2}
                        </h5>

                        <div className="d-flex  gap-2">
                          <span
                            className={`${pr === 7
                              ? "d-block text-green"
                              : pr === 8
                                ? "d-block text-red"
                                : pr === 5
                                  ? "d-block text-red"
                                  : pr === 6
                                    ? "d-block text-green"
                                    : "d-none"
                              }`}
                          >
                            {"=>"}
                            {pr === 5 ? -money : pr === 6 ? -money : pr === 7 ? profit : -profit}
                          </span>
                          SUSPENDED

                          {back2.slice().reverse().map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index < back2.length - 1
                                  ? "bg-secondary dnone"
                                  : "bg-info"
                                }`}
                              onClick={() => {
                                setbackActive(2);
                                setlayActive(3);
                                setSelectedPrice(bc.price);
                                setPr(3);
                                setSelectedId(selectionid2);
                                setRunner(runner2);
                                setSelectedBet(0);
                              }}
                              style={{ width: '4rem' }}
                            >
                              {bc.price}
                            </div>
                          ))}

                          {lay2.map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                              onClick={() => {
                                setlayActive(5);
                                setbackActive(0);
                                setSelectedPrice(bc.price);
                                setPr(4);
                                setSelectedId(selectionid2);
                                setRunner(runner2);
                                setSelectedBet(0);
                              }}
                              style={{ width: '4rem' }}
                            >
                              {bc.price}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="match-section">
                    <div className="match-header d-flex align-items-end gap-2 ">
                      <div className="d-flex flex-lg-row flex-column  flex-md-row align-items-baseline">
                        <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                          BM 1ST SET WINNER
                        </p>
                        <p className="d-flex gap-1 fszz">
                          <span>
                            Min:100 <span>|</span>{" "}
                          </span>{" "}
                          Max:50k
                        </p>
                      </div>
                      <BetModal betData={betData} />

                      <p className="btn btn-success rounded-pill text-black" style={{ marginBottom: "14px" }}>
                        <i className="bi bi-book"></i>
                      </p>

                      <div
                        className="d-flex align-items-end gap-4 ms-0 ms-md-auto me-4 mt-2 mt-md-0"
                        style={{ height: "5rem" }}
                      >
                        <p className="text-info fs-5">Back</p>
                        <p className="text-pink fs-5">Lay</p>
                      </div>
                    </div>

                    <div
                      className="betting-options d-flex flex-column p-2 gap-2"
                      style={{ marginLeft: "-10px" }}
                    >
                      <div className="betting-row d-flex flex-md-row justify-content-between align-items-center border-2 bg-dark p-2">
                        <h5 className="fs-4 text-wrap run" id={selectionid1}>
                          {runner1}
                        </h5>

                        <div className="d-flex gap-2">
                          SUSPENDED

                          {back1.slice().reverse().map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${index < back1.length - 1
                                ? "bg-secondary dnone"
                                : "bg-info"
                                }`}
                              onClick={() => {
                                setbackActive(1);
                                setlayActive(3);
                                setSelectedPrice(bc.price);
                                setPr(1);
                                setSelectedId(selectionid1);
                                setRunner(runner1);
                                setSide('Back');
                                setSelectedBet(0)
                              }}
                              style={{ width: '4rem' }}
                            >
                              {bc.price}
                            </div>
                          ))}



                          {lay1.map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                              onClick={() => {
                                setlayActive(4);
                                setbackActive(0);
                                setSelectedPrice(bc.price);
                                setPr(2);
                                setSelectedId(selectionid1);
                                setRunner(runner1);
                                setSide('Lay');
                                setSelectedBet(0);
                              }}
                              style={{ width: '4rem' }}
                            >
                              {bc.price}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-2 bg-dark p-2">
                        <h5 className="fs-4 text-wrap run" id={selectionid2}>
                          {runner2}
                        </h5>

                        <div className="d-flex  gap-2">
                          SUSPENDED

                          {back2.slice().reverse().map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index < back2.length - 1
                                ? "bg-secondary dnone"
                                : "bg-info"
                                }`}
                              onClick={() => {
                                setbackActive(2);
                                setlayActive(3);
                                setSelectedPrice(bc.price);
                                setPr(3);
                                setSelectedId(selectionid2);
                                setRunner(runner2);
                                setSelectedBet(0);
                              }}
                              style={{ width: '4rem' }}
                            >
                              {bc.price}
                            </div>
                          ))}

                          {lay2.map((bc, index) => (
                            <div
                              className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                              onClick={() => {
                                setlayActive(5);
                                setbackActive(0);
                                setSelectedPrice(bc.price);
                                setPr(4);
                                setSelectedId(selectionid2);
                                setRunner(runner2);
                                setSelectedBet(0);
                              }}
                              style={{ width: '4rem' }}
                            >
                              {bc.price}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    
                    {backActive !== 0 && (
                      <div style={{ backgroundColor: "#052e36", padding: "15px", color: "white", borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button
                            style={{ backgroundColor: "#0A6E8A", color: "white", padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            BACK
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button
                                style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                style={{ backgroundColor: "#064150", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button
                                style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button
                                style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                style={{ backgroundColor: "#064150", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button
                                style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: "#166534", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: "#1e3a8a", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: "#7e22ce", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button
                            style={{ backgroundColor: "#991b1b", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button
                            style={{ backgroundColor: "#ef4444", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button
                            style={{ backgroundColor: "#22c55e", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                    )}
                    {layActive !== 3 && (
                      <div style={{ backgroundColor: "rgb(29 5 32)", padding: "15px", color: "white", borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            Lay
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button
                                style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                style={{ backgroundColor: "#36013c", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button
                                style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button
                                style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                style={{ backgroundColor: "#36013c", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button
                                style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: "#166534", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: "#1e3a8a", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: "#7e22ce", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button
                            style={{ backgroundColor: "#991b1b", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button
                            style={{ backgroundColor: "#ef4444", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button
                            style={{ backgroundColor: "#22c55e", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                    )}
                  </div> */}
                  {/* <div className="match-section">
                    <div className="match-header d-flex align-items-end gap-2 ">
                      <div className="d-flex flex-lg-row flex-column  flex-md-row align-items-baseline">
                        <p className="bg-yellow text-black pt-2 pb-2 me-3 px-2 rad bett">
                          BM 2ND SET WINNER
                        </p>
                        <p className="d-flex gap-1 fszz">
                          <span>
                            Min:100 <span>|</span>{" "}
                          </span>{" "}
                          Max:50k
                        </p>
                      </div>
                      <BetModal betData={betData} />

                      <p className="btn btn-success rounded-pill text-black" style={{ marginBottom: "14px" }}>
                        <i className="bi bi-book"></i>
                      </p>

                      <div
                        className="d-flex align-items-end gap-4 ms-0 ms-md-auto me-4 mt-2 mt-md-0"
                        style={{ height: "5rem" }}
                      >
                        <p className="text-info fs-5">Back</p>
                        <p className="text-pink fs-5">Lay</p>
                      </div>
                    </div>

                    <div
                      className="betting-options d-flex flex-column p-2 gap-2"
                      style={{ marginLeft: "-10px" }}
                    >
                      <div className="betting-row d-flex flex-md-row justify-content-between align-items-center border-2 bg-dark p-2">
                        <h5 className="fs-4 text-wrap run" id={selectionid1}>
                          {runner1}
                        </h5>

                        <div className="d-flex gap-2">
                          SUSPENDED
                          
                            {back1.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${
                                  index < back1.length - 1
                                    ? "bg-secondary dnone"
                                    : "bg-info"
                                }`}
                                onClick={() => {
                                  setbackActive(1);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(1);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Back');
                                  setSelectedBet(0)
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}

                        

                            {lay1.map((bc, index) => (
                              <div
                                className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(4);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(2);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Lay');
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                        </div>
                      </div>

                      <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-2 bg-dark p-2">
                        <h5 className="fs-4 text-wrap run" id={selectionid2}>
                          {runner2}
                        </h5>

                        <div className="d-flex  gap-2">
                          SUSPENDED
                                                 
                            {back2.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${
                                  index < back2.length - 1
                                    ? "bg-secondary dnone"
                                    : "bg-info"
                                }`}
                                onClick={() => {
                                  setbackActive(2);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(3);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                            
                            {lay2.map((bc, index) => (
                              <div
                                className={`rounded p-2 fs-5 h-100 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(5);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(4);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>

                  
                    {backActive !== 0 && (
                        <div style={{ backgroundColor: "#052e36", padding: "15px", color: "white", borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: "#0A6E8A", color: "white", padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            BACK
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div    style={{ display: "flex", alignItems: "center" }  }>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                style={{ backgroundColor: "#064150", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                                >+</button>
                            </div>
                          </div>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                style={{ backgroundColor: "#064150", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: "#166534", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: "#1e3a8a", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: "#7e22ce", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: "#991b1b", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ backgroundColor: "#ef4444", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ backgroundColor: "#22c55e", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )}
                         {layActive !== 3 && (
                        <div style={{ backgroundColor: "rgb(29 5 32)", padding: "15px", color: "white", borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            Lay
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                style={{ backgroundColor: "#36013c", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                style={{ backgroundColor: "#36013c", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: "#166534", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: "#1e3a8a", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: "#7e22ce", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: "#991b1b", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ backgroundColor: "#ef4444", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ backgroundColor: "#22c55e", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )}
                  </div> */}
                </div>

                <div className="bets-container d-flex flex-column betTv  gap-5 ">
                  <div className="d-none d-lg-block position-relative pl-1 ">
                    {" "}
                    {/* Added position relative */}
                    <div
                      className=" p-2 cursor-pointer d-flex justify-content-between"
                      style={{ background: "#212121" }}
                      onClick={() => setPlay(!play)}
                    >
                      <div>
                        <span>
                          {" "}
                          <i
                            className="bi bi-broadcast fs-16"
                            style={{ color: "#DC3545" }}
                          ></i>
                        </span>
                        <span> Watch Live Match</span>
                      </div>
                      <div>
                        <button className="live-stream-button ng-star-inserted">
                          {" "}
                          Watch Live{" "}
                        </button>
                      </div>
                    </div>
                    {play && (
                      <iframe
                        title="Live TV"
                        className="border w-100 h-75"
                        src={`https://5por-tt1.top/directstreaming.php?chid=${channel}`}
                        allowFullScreen
                        referrerPolicy="strict-origin-when-cross-origin"
                        sandbox="allow-same-origin allow-scripts"
                      ></iframe>
                    )}
                  </div>

                  <div
                    className="table-responsive rounded-4 mt-3 mt-lg-0 ms-0 ms-lg-1 mb-4  h-100"
                    style={{
                      maxHeight: "100vh",
                      height: `${betData.length * 6}vh`,
                    }}
                  >
                    <div
                      className="m-0 rounded-top-3 p-2 bett"
                      style={{
                        background:
                          "linear-gradient(to right, #f2d71a, #ecb024)",
                        color: "#000",
                      }}
                    >
                      My Bets
                    </div>

                    <table
                      className="border  w-100"
                      style={{ borderCollapse: "collapse" }}
                    >
                      <thead>
                        <div
                          style={{
                            color: "black",
                            fontFamily: "sans-serif",
                          }}
                          className="pl-1"
                        >
                          Unmatched bets
                        </div>
                        <tr className="text-dark">
                          <th>Runner Name</th>
                          <th>ODDS</th>
                          <th>Bet Amount</th>
                          <th>P/L</th>
                        </tr>
                      </thead>

                      <tbody>
                        {unmatch?.length > 0 ? (
                          unmatch?.map((bet, index) => (
                            <tr key={index} className="text-dark"
                              style={{
                                background: bet.side === 'Lay'
                                  ? 'linear-gradient(180deg, #f59dc2, #f5e9ee)'
                                  : 'linear-gradient(180deg, #84c2f1, #d9efff)'
                              }}>
                              <td>
                                {bet.runnerName}&nbsp;({bet.type})
                              </td>
                              <td>{bet.betprice}</td>
                              <td>{bet.betAmount}</td>
                              <td>{bet.profit}</td>
                            </tr>
                          ))
                        ) : (
                          <tr></tr>
                        )}
                      </tbody>
                    </table>
                    <table
                      className="border  w-100"
                      style={{ borderCollapse: "collapse" }}
                    >
                      <thead>
                        <div
                          style={{
                            color: "black",
                            fontFamily: "sans-serif",
                          }}
                          className="pl-1"
                        >
                          Matched bets
                        </div>
                        <tr className="text-dark">
                          <th>Phone</th>

                          <th className="headerColor">Runner Name</th>
                          <th>ODDS</th>
                          <th>Bet Amount</th>
                          <th>P/L</th>
                        </tr>
                      </thead>

                      <tbody>
                        {/* Sports Bets */}
                        {betData?.length > 0 ? (
                          <>
                            <tr className="text-dark">
                              <th
                                colSpan={4}
                                style={{
                                  background: "#000",
                                  color: "#fff",
                                }}
                              >
                                Sports Bets
                              </th>
                            </tr>
                            {betData.map((bet, index) => (
                              <tr key={`sports-${index}`} className="text-dark"
                                style={{
                                  background: bet.side === 'Lay'
                                    ? 'linear-gradient(180deg, #f59dc2, #f5e9ee)'
                                    : 'linear-gradient(180deg, #84c2f1, #d9efff)'
                                }}>
                                <td>{bet.phone}</td>
                                <td>
                                  {bet.runnerName} ({bet.type})
                                </td>
                                <td>{bet.betprice}</td>
                                <td>{bet.betAmount}</td>
                                <td>{bet.profit}</td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr className="text-dark">
                            <td
                              colSpan={4}
                              style={{ color: "gray", textAlign: "center" }}
                            >
                              No sports bet data
                            </td>
                          </tr>
                        )}

                        {/* Fancy Bets */}
                        {fancyBetData?.length > 0 ? (
                          <>
                            <tr className="text-dark">
                              <th
                                colSpan={4}
                                style={{
                                  background: "#000",
                                  color: "#fff",
                                }}
                              >
                                Fancy Bets
                              </th>
                            </tr>
                            {fancyBetData.map((bet, index) => (
                              <tr key={`fancy-${index}`} className="text-dark"
                                style={{
                                  background: bet.side === 'no'
                                    ? 'linear-gradient(180deg, #f59dc2, #f5e9ee)'
                                    : 'linear-gradient(180deg, #84c2f1, #d9efff)'
                                }}>
                                <td>{bet.phone}</td>
                                <td>
                                  {bet.runnerName} ({bet.type})
                                </td>
                                <td>{bet.rate}</td>
                                <td>{bet.betAmount}</td>
                                <td>{bet.profit}</td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr className="text-dark">
                            <td
                              colSpan={4}
                              style={{ color: "gray", textAlign: "center" }}
                            >
                              No fancy bet data
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeTennis;